
<template>
  <!--新增楼栋-->
  <x-addEdit
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
  >
  </x-addEdit>
</template>

<script>
import {fetchSelect, userRange} from '@/utils/mixins';
import { addEdit } from 'ant-design-vue-admin-x';
export default {
  mixins: [fetchSelect, addEdit, userRange],
  name: 'addBuilding',
  data () {
    let decoratorOptions = {
      communityId: {
        rules: [{ required: true, message: '请选择所属小区' }]
      },
      buildingName: {
        validateTrigger: 'blur',
        rules: [
          { required: true, message: '请输入楼栋名' },
          { pattern: this.REG.name, message: '楼栋名为2-20位汉字、字母、数字' }
        ]
      },
      buildingNo: {
        validateTrigger: 'blur',
        rules: [
          { required: true, message: '输入楼栋编号' },
          { min: 1, max: 2, message: '楼栋编号为1-2个字' }
        ]
      }
    };
    return {
      formList: [
        {
          label: '所属小区',
          inputType: 'select',
          options: [],
          placeholder: '请选择所属小区',
          disabled: false,
          fetchOptions: this.getOptions,
          props: ['communityId', decoratorOptions.communityId]
        },
        {
          label: '楼栋名',
          inputType: 'input',
          options: [],
          placeholder: '请输入楼栋名',
          props: ['buildingName', decoratorOptions.buildingName]
        },
        {
          label: '楼栋编号',
          inputType: 'input',
          options: [],
          placeholder: '请输入楼栋编号',
          type: 'number',
          props: ['buildingNo', decoratorOptions.buildingNo]
        }
      ],
      formKey: {
        communityId: '',
        buildingName: '',
        buildingNo: ''
      },
      addParam: {
        url: '/building',
        reqHandle: '', // this.reqHandle
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/building/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/building/',
        resHandle: this.resHandle // this.resHandle
      }
    };
  },
  computed: {
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    getOptions (pageNum, search, item) {
      return this.communitySelectByStep(pageNum, search, undefined, '0', item.communityId);
    },
    /* 获取下拉 */
    getSelect () {
      // this.communitySelect(0, 'formList', 1);
      this.communitySelectByStep(1, undefined, undefined, '0');
    },
    resHandle (res) {
      this.limitEdit(res, ['communityId']);

      let arr = this.formList[0].options;

      this.formList[0].communityId = res.communityId;
      this.communitySelectByStep(1, undefined, undefined, '0', res.communityId);

      return {};
    },
    reqHandle (param) {
      return param;
    },
    addResHandle (res) {
      return res;
    },
    editResHandle (res) {
      return res;
    }
  }
};
</script>
